<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader :title="$t('Users')" :description="$t('from Here You Can Control Users')" />
        <indexTable
          :searchText="$t('search For A User')"
          :emptyTableText="$t('there Are No Users')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('users_add')"
          :localData="true"
          :cloumns="[
            {
              column: 'name',
              title: $t('name'),
              type: 'text',
              sort: true
            },
            { column: 'role_name', title: $t('userType'), type: 'text' },
            {
              column: 'email',
              title: $t('email'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: $checkRole('users_edit') },
                {
                  name: 'delete',
                  role: $checkRole('users_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/users'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
